var map = {
	"./bernathlevente.jpg": 371,
	"./bernathlevente_grad.jpg": 372,
	"./damiano_grad.jpg": 373,
	"./ekedaniel.jpg": 374,
	"./ekedaniel_grad.jpg": 375,
	"./rakosifanni_grad.jpg": 376,
	"./szanthoandras.jpg": 377,
	"./szanthoandras_grad.jpg": 378
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;



//////////////////
// WEBPACK FOOTER
// ./src/assets/team nonrecursive \.jpg$
// module id = 436
// module chunks = 2